import { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import CustomButton from "shared/components/common/customButton";
import {
  CreateUpdatePolicyService,
  GetSinglePolicyService,
} from "shared/services/policies";
import CustomTextEditor from "shared/components/common/customTextEditor";
import { toastMessage } from "shared/components/common/toast";

const TermsAndConditions = () => {
  const [terms, setTerms] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const validationSchema = Yup.object({
    content: Yup.string().required("Content is required"),
  });

  const formik = useFormik({
    initialValues: {
      // @ts-ignore
      content: terms?.content,
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: async (values) => {
      try {
        if (formik.values.content !== terms) {
          setLoading(true);
          setTerms(formik.values.content);
          await CreateUpdatePolicyService(0, values.content);
          toastMessage("success", "Policy saved successfully!");
        }
      } catch (error) {
        toastMessage("error", "Failed to save policy.");
      } finally {
        setLoading(false);
      }
    },
  });

  const handleGetTerms = async () => {
    try {
      const response = await GetSinglePolicyService(0);
      const termsData = response.data.data;
      setTerms(termsData);
    } catch (error) {
      console.error("Error fetching Terms:", error);
    }
  };

  useEffect(() => {
    handleGetTerms();
  }, []);

  return (
    <div>
      <h1 className="font-medium">Terms And Conditions</h1>
      <form onSubmit={formik.handleSubmit}>
        <div className="my-4">
          <CustomTextEditor
            value={formik.values.content || terms}
            onChange={(value) => formik.setFieldValue("content", value)}
            placeholder=""
          />
          {formik.touched.content &&
            formik.values.content &&
            formik.errors.content && (
              <div className="error">{formik.errors.content}</div>
            )}
        </div>

        <div className="flex justify-end">
          <CustomButton
            title="Create/ Update"
            loading={loading}
            type="submit"
          />
        </div>
      </form>
    </div>
  );
};

export default TermsAndConditions;
